<!--
/*******************************************************************************
*@ 컴포넌트명   : SaveAndShare.vue
*@ 컴포넌트설명 : [공통]영역 이미지 저장 및 공유하기 컴포넌트
*@ 사용전문     :
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 2023.08.23  최지영    영역 이미지 저장 및 공유하기 컴포넌트 신규
********************************************************************************/
-->
<template>
  <section>
    <div class="btn-area--icon al_bottomcenter" v-if="showType == 'A'">
      <button class="btn icon" @click.prevent="click('save')">
        <i class="icon icon-download-02"></i>
        <em>저장</em>
      </button>
      <button class="btn icon" @click.prevent="click('share')">
        <i class="icon icon-share"></i>
        <em>공유</em>
      </button>
    </div>
    <div class="btn-area--full fixed" v-if="showType == 'B'">
      <button class="btn md gray" @click.prevent="click('save')">
        <i class="icon icon-download-02"></i>
        {{ /*저장*/ $t("MPAY-01-01-26-07") }}
      </button>
      <button class="btn md gray" @click.prevent="click('share')">
        <i class="icon icon-share"></i>
        {{ /*공유*/ $t("MPAY-05-01-01-31") }}
      </button>
    </div>
    <!-- <div id="printArea" style="disply:none"></div> -->
    <div :class="['toasts', { hide: hasFlaggedItems }]">
      <div class="toast" v-for="item in items" :key="item.id" :id="item.id">
        <div class="toast-body">
          <i class="icon icon-check" />
          {{ item.body }}
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import html2canvas from "@/assets/js/html2canvas.js"; // html -> image
import { mapFields } from "vuex-map-fields";

export default {
  name: "SaveAndShare",
  props: {
    showType: { type: String, default: "A" },
    isMyqr: { type: Boolean, default: false },
    isSelected: { type: Boolean, default: false },
  },
  computed: {
    ...mapFields("transfer", ["isActive", "isAmount", "isShowAmt", "arrowNone"]),
    hasFlaggedItems() {
      return this.items.some(i => i.flaggedForRemoval);
    },
  },
  components: {},
  mounted() {},
  data() {
    return {
      items: [],
    };
  },
  methods: {
    saveAs(uri, filename) {
      var link = document.createElement("a");
      if (typeof link.download === "string") {
        link.href = uri;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        window.open(uri);
      }
      console.log("Uri : " + uri);
    },

    // 계좌번호 선택할 때 캡처/공유 -> arrow 안보이게 & 500ms 이후에는 다시 보이게
    arronwNoneTypeChange(eventType) {
      // Save or Share 버튼 클릭 발생
      if (eventType == "click") this.arrowNone = true;
      else this.arrowNone = false;
    },

    removeQRCode() {
      // QR 내용 삭제할 것
      var container = document.getElementById("myQr2");
      while (container.firstChild) {
        container.removeChild(container.firstChild);
      }
    },

    // 타입에 따라 캡처 / 공유 진행
    doCaptureType(type) {
      // QR 다시 넣은뒤 캡처/공유 작업
      let area2 = this.$parent.$refs.captureBody;
      let width2 = area2.clientWidth;
      let height2 = area2.clientHeight;

      var _this = this;
      setTimeout(function () {
        if (type == "save") {
          _this.$bridge.sendCaptureMyQRToApp(width2, height2);
        } else {
          _this.$bridge.shareCaptureMyQR(width2, height2);
        }
      }, 100);
    },
    // myQR Save & Share 작업용
    myQRSaveAndShare(type) {
      //let html = document.documentElement;
      // let myQr2 = document.getElementById("myQr2");
      // let currentTransform = window.getComputedStyle(myQr2).transform;

      //html.style.fontSize = "80%"
      //myQr2.style.transform = "translate(-60%, -11%) scale(0.8)";
      // 금액 보이는 상태
      var _this = this;
      if (this.isAmount == true) {
        this.isShowAmt = true; // true로 주어야 미지정~1,000,000 클릭 박스가 FALSE로 보이게 되어 안보일 것
        this.doCaptureType(type);

        setTimeout(function () {
          _this.isShowAmt = false;
          _this.arronwNoneTypeChange(""); // 원상복구 arrowNone -> false
          // html.style.fontSize = "100%"
          //myQr2.style.transform = currentTransform;
          _this.callToast();
        }, 400);
      } // 금액 보이지 않은 상태
      else {
        this.isShowAmt = false; // 금액추가 버튼 안보이도록 구현

        this.doCaptureType(type);

        setTimeout(function () {
          _this.isShowAmt = true;
          _this.arronwNoneTypeChange(""); // 원상복구 arrowNone -> false
          //html.style.fontSize = "100%"
          //myQr2.style.transform = currentTransform;
          _this.callToast();
        }, 400);
      }
    },
    // 프론트 웹 상에서 이미지가 잘 받아지는지만 보기 위해 테스트 용 함수
    click(type) {
      // todo : 유효성 체크
      if (this.isMyqr && !this.isSelected) {
        this.$emit("showInvalid");
        return;
      }

      // this.isActive myQR일 때 드롭박스에 arrow 제거하기 위해서 필요
      // this.$store.dispatch("actionInActive");
      //캡쳐영역 이미지로 생성
      this.isActive = true;

      if (this.showType == "A") {
        let area = this.$parent.$refs.captureBody;
        let promise = new Promise(resolve => {
          resolve(
            html2canvas(area, { scrollY: 0, height: this.$parent.$refs.saveNShare.$el.offsetTop }).then(function (canvas) {
              var image = canvas.toDataURL("image/jpeg", 1.0);
              console.log("image", image);
              return image;
            }),
          );
          //reject("html to image convert failed");
        });
        promise
          .then(result => {
            if (type == "save") {
              let now = new Date();
              this.$bridge.sendCaptureImgToApp(result, `${now}.jpg `);
              this.callToast();
            } else {
              this.$bridge.shareCaptureImg(result);
            }
          })
          .catch(error => {
            console.log(error);
          });
      }
      // myQr
      else {
        // var _this = this;
        //let area2 = document.getElementById("captureBody");
        let area2 = this.$parent.$refs.captureBody;
        let width2 = area2.clientWidth;
        let height2 = area2.clientHeight;
        console.log("width : " + width2 + "/// height : " + height2);

        // arrowNone 타입을 변경 = Save & Share 버튼 클릭시 click으로 타입 변경 > arrowNone true로 두어 화살표가 보이지 않도록 구현
        let arNonePromise = new Promise(resolve => {
          resolve(this.arronwNoneTypeChange("click"));
        });

        // 이벤트 발생 이후 UI가 변경이 된 것을 확인한 다음에 Save & Share 진행 (타입 같이 보내서 캡처인지 공유인지 확인)
        arNonePromise.then(() => {
          console.log("Arrow None : " + this.arrowNone); // true 안보이게 , false 보이게 (화살표)
          this.myQRSaveAndShare(type);
        });
      }
    },
    callToast() {
      const toast = {
        id: Date.now(),
        body: this.$t(/*이미지 저장이 완료되었습니다.*/ "MPAY-05-01-01-32"),
        flaggedForRemoval: false,
      };
      this.items.unshift(toast);
      setTimeout(() => this.close(toast), 1000); // toast 머무는 시간
    },
    close(toast) {
      const index = this.items.indexOf(toast);
      this.items.splice(index, 1);
      toast.flaggedForRemoval = true;

      document.getElementById(toast.id).addEventListener("transitionend", () => this.remove(toast));
    },
    remove(toast) {
      const index = this.items.indexOf(toast);
      this.items.splice(index, 1);
    },
  },
};
</script>
